const RESULTS_LIST_SELECTOR = 'results-list';
const REGISTERED_ATTR = 'data-impronte-count-sync-registered';
const TEMPLATE_TOKEN = '__COUNT__';

function getPluralKey(count) {
  if (count === 1) return 'one';
  return 'other';
}

function formatCount(target, count) {
  if (!(target instanceof HTMLElement)) return '';

  const pluralKey = getPluralKey(count);
  const template =
    target.dataset[`impronteTemplate${pluralKey.charAt(0).toUpperCase()}${pluralKey.slice(1)}`] ||
    target.dataset.impronteTemplateOther ||
    '';

  return template.replace(TEMPLATE_TOKEN, `${count}`);
}

function updateResultsCount(resultsList) {
  if (!(resultsList instanceof HTMLElement)) return;

  const grid = resultsList.querySelector('[ref="grid"]');
  if (!(grid instanceof HTMLElement)) return;

  const count = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
  const targets = resultsList.querySelectorAll('[data-impronte-count-sync]');

  for (const target of targets) {
    if (!(target instanceof HTMLElement)) continue;

    const text = formatCount(target, count);
    if (text) {
      target.textContent = text;
    }
  }
}

function registerResultsList(resultsList) {
  if (!(resultsList instanceof HTMLElement) || resultsList.hasAttribute(REGISTERED_ATTR)) return;

  resultsList.setAttribute(REGISTERED_ATTR, 'true');

  let frame = 0;
  const scheduleUpdate = () => {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = 0;
      updateResultsCount(resultsList);
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.target instanceof HTMLElement && mutation.target.closest('[ref="grid"]')) {
        scheduleUpdate();
        return;
      }

      for (const node of [...mutation.addedNodes, ...mutation.removedNodes]) {
        if (!(node instanceof Element)) continue;

        if (
          node.matches('[ref="grid"], [ref="cards[]"]') ||
          node.querySelector('[ref="grid"], [ref="cards[]"]')
        ) {
          scheduleUpdate();
          return;
        }
      }
    }
  });
  observer.observe(resultsList, {
    childList: true,
    subtree: true,
  });

  scheduleUpdate();
}

function registerResultsLists(root = document) {
  const resultsLists = [];

  if (root instanceof Element && root.matches(RESULTS_LIST_SELECTOR)) {
    resultsLists.push(root);
  }

  if (root && typeof root.querySelectorAll === 'function') {
    resultsLists.push(...root.querySelectorAll(RESULTS_LIST_SELECTOR));
  }

  for (const resultsList of resultsLists) {
    registerResultsList(resultsList);
  }
}

registerResultsLists();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      registerResultsLists(node);
    }
  }
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
